<div class="grid-tiles grid-tiles--mt0 visible-desktop">
	<div class="inner clearfix " *ngFor="let row of desktopData">
		<ng-container *ngIf="row.type==0">
			<div class="one-second-cell cell">
				<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'3x2'" [classList]="'plate--two-height'"></tile-item>
			</div>
			<div class="one-second-cell cell">
				<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [imageType]="'1x1'" [classList]="'third'"></tile-item>
				<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [imageType]="'1x1'" [classList]="'third ml'"></tile-item>
				<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [imageType]="'1x1'" [classList]="'third ml'"></tile-item>
			</div>
		</ng-container>

		<ng-container *ngIf="row.type==1">
			<div class="one-second-cell cell">
				<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'1x1'" [classList]="'third'"></tile-item>
				<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [imageType]="'1x1'" [classList]="'third ml'"></tile-item>
				<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [imageType]="'1x1'" [classList]="'third ml'"></tile-item>
			</div>
			<div class="one-second-cell  cell cell--up">
				<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [imageType]="'3x2'" [classList]="'plate--two-height'"></tile-item>
			</div>
		</ng-container>

		<ng-container *ngIf="row.type==2">
			<div class="one-second-cell cell">
				<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'1x1'" [classList]="'third'"></tile-item>
				<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [imageType]="'1x1'" [classList]="'third ml'"></tile-item>
				<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [imageType]="'1x1'" [classList]="'third ml'"></tile-item>
			</div>
			<div class="one-second-cell cell">
				<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [imageType]="'1x1'" [classList]="'third'"></tile-item>
				<tile-item *ngIf="row.data[4]" [srcUrl]="srcUrl" [dataItem]="row.data[4]" [imageType]="'1x1'" [classList]="'third ml'"></tile-item>
				<tile-item *ngIf="row.data[5]" [srcUrl]="srcUrl" [dataItem]="row.data[5]" [imageType]="'1x1'" [classList]="'third ml'"></tile-item>
			</div>
		</ng-container>
	</div>
</div>

<div class="grid-tiles visible-tablet grid-tiles--mt0">
	<div class="inner clearfix " *ngFor="let row of tabletData">
		<ng-container *ngIf="row.type==0">
			<div class="one-third-cell cell">
				<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'2x2'" [classList]="'plate--two-height'"></tile-item>
			</div>
			<div class="one-third-cell cell">
				<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [imageType]="'1x1'" [classList]="'hw'"></tile-item>
				<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [imageType]="'1x1'" [classList]="'hw ml'"></tile-item>
			</div>
			<div class="one-sixth-cell cell">
				<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [imageType]="'1x1'"></tile-item>
			</div>
		</ng-container>

		<ng-container *ngIf="row.type==1">
			<div class="one-third-cell cell">
				<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'1x1'" [classList]="'hw'"></tile-item>
				<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [imageType]="'1x1'" [classList]="'hw ml'"></tile-item>
			</div>
			<div class="one-sixth-cell v-cell cell cell--up">
				<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [imageType]="'1x1'" [classList]="'hw mb'"></tile-item>
				<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [imageType]="'1x1'" [classList]="'hw'"></tile-item>
			</div>
			<div class="one-third-cell cell cell--up">
				<tile-item *ngIf="row.data[4]" [srcUrl]="srcUrl" [dataItem]="row.data[4]" [imageType]="'2x2'" [classList]="'plate--two-height'"></tile-item>
			</div>
		</ng-container>
	</div>
</div>

<div class="grid-tiles visible-mobile grid-tiles--mt0">
	<div class="inner clearfix " *ngFor="let row of mobileData">
		<ng-container *ngIf="row.type==0">
			<div class="cell">
				<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'2x2'" [classList]="'plate--two-height'"></tile-item>
			</div>
			<div class="cell">
				<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [imageType]="'2x2'" [classList]="'plate--two-height'"></tile-item>
			</div>
		</ng-container>

		<ng-container *ngIf="row.type==1">
			<div class="cell">
				<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'1x1'" [classList]="'hw'"></tile-item>
				<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [imageType]="'1x1'" [classList]="'hw ml'"></tile-item>
			</div>
			<div class="cell">
				<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [imageType]="'1x1'" [classList]="'hw'"></tile-item>
				<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [imageType]="'1x1'" [classList]="'hw ml'"></tile-item>
			</div>
		</ng-container>

		<ng-container *ngIf="row.type==2">
			<div class="cell">
				<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'2x2'" [classList]="'plate--two-height'"></tile-item>
			</div>
			<div class="cell">
				<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [imageType]="'1x1'" [classList]="'hw'"></tile-item>
				<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [imageType]="'1x1'" [classList]="'hw ml'"></tile-item>
			</div>
		</ng-container>
	</div>
</div>
